import toast from 'react-hot-toast'
import request from 'utils/request'


interface ApiSubmitTicketParams {
    hash: string
    chain: string
}
/**
 * 提交票务系统
 * @param params 
 * @param headers 
 */
export const postSubmitTicket = async (params: ApiSubmitTicketParams, headers: {[key:string]: any}) => {
    try {
        const {code = -1, data = {}, msg=''}: any = await request.post('/submitTicket', params, {
            headers: headers
        })
        if(code === 0) {
            return true
        }
        toast.error(msg, {
            duration: 3000,
            position: 'top-right',
        })
        return false
    } catch(error) {
        throw error
    }
}

interface ApiGetAllTicketByAddressParams {
    address: string
}
/**
 * 获取所有的ticket 列表
 * @param params 
 */
export const getAllTicketByAddress = async(params: ApiGetAllTicketByAddressParams) => {
    try {
        const {code = -1, data = {}}: any = await request.get('/getAllTicketByAddress', {params: params})
        if(code === 0) {
            return data.list || []
        }
        return []
    } catch(error) {
        throw error
    }
}

/**
 * 检查票务
 * @param params 
 */
export const getCheckTicket = async(ticketId: string) => {
    try {
        const {code = -1, data = {}}: any = await request.get('/checkTicket', {params: {ticketId: ticketId}})
        if(code === 0) {
        }
    } catch(error) {
        throw error
    }
}